import { FormControl, FormControlProps } from "@chakra-ui/react"

const ContactFormControl = ({ children, ...props }: FormControlProps) => {
  return (
    <FormControl p={4} my={6} {...props}>
      {children}
    </FormControl>
  )
}

export default ContactFormControl
